function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Cart = function Cart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size > 16 ? 0 : 0.8,
    stroke: props.size <= 16 ? props.color ? props.color : "#242328" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    d: "M1.25 4A.75.75 0 0 1 2 3.25h2.594a1.75 1.75 0 0 1 1.685 1.28l.405 1.447H20c.966 0 1.75.784 1.75 1.75v3.065a1.75 1.75 0 0 1-1.457 1.725l-11.248 1.91.179.64a.25.25 0 0 0 .24.183H21a.75.75 0 0 1 0 1.5H9.465a1.75 1.75 0 0 1-1.686-1.28L4.835 4.934a.25.25 0 0 0-.24-.183H1.999A.75.75 0 0 1 1.25 4m7.39 8.974 11.402-1.936a.25.25 0 0 0 .208-.246V7.727a.25.25 0 0 0-.25-.25H7.103zM11 19.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m8.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M1.25 4A.75.75 0 0 1 2 3.25h2.594a1.75 1.75 0 0 1 1.685 1.28l.405 1.447H20c.966 0 1.75.784 1.75 1.75v3.065a1.75 1.75 0 0 1-1.457 1.725l-11.248 1.91.179.64a.25.25 0 0 0 .24.183H21a.75.75 0 0 1 0 1.5H9.465a1.75 1.75 0 0 1-1.686-1.28L4.835 4.934a.25.25 0 0 0-.24-.183H1.999A.75.75 0 0 1 1.25 4m7.39 8.974 11.402-1.936a.25.25 0 0 0 .208-.246V7.727a.25.25 0 0 0-.25-.25H7.103zM11 19.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m8.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
    clipRule: "evenodd"
  }));
};
export default Cart;
Cart.displayName = 'Cart';